import g, { createContext as w, useState as n, useEffect as a, useContext as l } from "react";
const s = w(void 0), y = ({ measurementId: e, children: r }) => {
  const [i, c] = n(null), [o, d] = n(!1);
  return a(() => {
    const t = document.createElement("script");
    t.async = !0, t.addEventListener("load", () => d(!0)), t.src = `https://www.googletagmanager.com/gtag/js?id=${e}`, document.head.prepend(t);
  }, []), a(() => {
    o && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
      window.dataLayer.push(arguments);
    }, window.gtag("js", new Date()), window.gtag("config", e), c(() => (...t) => window.gtag(...t)));
  }, [e, o]), /* @__PURE__ */ g.createElement(s.Provider, { value: i }, r);
}, f = () => {
  const e = l(s);
  if (e === void 0)
    throw new Error(
      "useGoogleAnalytics must be used within a GoogleAnalyticsProvider"
    );
  return e;
};
export {
  s as GoogleAnalyticsContext,
  y as GoogleAnalyticsProvider,
  f as useGoogleAnalytics
};
